import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CategoryItem } from '@/common/interfaces/modules/DatesAndRates';

import CabinPrice from '../CabinPrice/CabinPrice.vue';

@Component({
  components: { CabinPrice },
})
export default class CabinCategoryItem extends Vue {
  @Prop({ type: Object as () => CategoryItem, default: {} })
  readonly Category!: CategoryItem;

  showCabinOnSvg(code: any) {
    this.$emit('showCabinOnSvg', code);
  }
}
